module.exports = __webpack_public_path__ + "img/default-car.34cfc14d.png";